import { EventAdditionalApi } from 'api';
import { useAuthMutation, useQueryClient } from 'queries/query';
import { getQueryKeys } from 'queries/query-key';
import { KEY } from './keys';

function usePut() {
  const queryClient = useQueryClient();

  return useAuthMutation(EventAdditionalApi.patch, {
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getQueryKeys([KEY]).details(),
      });
    },
  });
}

export default usePut;
